import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import {
  Button,
  TextLink,
  Grid,
  Multiline,
  BaseLabel,
  SimpleToast,
} from "components";

import { customerCertificateServicesV2 } from "services/customerCertificate";

import { LogOperation } from "utils/entities/logOperation";
import { stringFormat } from "utils/stringFormat";

import { DivEmail, DivLogo, LeftFormContainer, LinkContainer } from "./styles";

type statusToast = "success" | "warning" | "error";

interface ICustomerCertificate {
  data: boolean;
  errors: [];
  message: string;
  ok: boolean;
}

export const CertificateForm: React.FC<{
  navigate?: any;
  navigateTo?: string;
  url?: string;
}> = ({ navigate, navigateTo }) => {
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [value, setValue] = useState<string>("");

  const [triggerToast, setTriggerToast] = useState<number>(0);
  const [toastMessage, setToastMessage] = useState("");
  const [typeToast, setTypeToast] = useState<statusToast>("warning");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (stringFormat.isEmptyOrSpaces(value)) {
      setToastMessage(t("auth.certificate.fillField"));
      setTypeToast("warning");
      setError(true);
      setTriggerToast(triggerToast + 1);
      return;
    } else {
      setError(false);

      const data: ICustomerCertificate =
        await customerCertificateServicesV2.importCertificate({
          textCrypted: value,
        });

      if (data.ok) {
        setToastMessage(data.message);
        setTypeToast("success");
        setTriggerToast(triggerToast + 1);
        if (navigate) navigate(navigateTo ?? "/");
        await LogOperation.postLogOperation("CustomerCertificate", 7, 7);
      } else {
        setToastMessage(data.message);
        setTypeToast("error");
        setTriggerToast(triggerToast + 1);
        return;
      }
    }
  };

  return (
    <LeftFormContainer>
      <SimpleToast
        trigger={triggerToast}
        id="simpleToastCertificate"
        title={t("auth.certificate.title")}
        description={toastMessage}
        type={typeToast}
        handleCloseToast={() => setTriggerToast(0)}
      />
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid alignContent="center">
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              //marginTop: "-54px",
              //marginTop: "-30px",
              marginTop: "-23px",
            }}
          >
            <DivLogo>
              <BaseLabel
                children={t("auth.certificate.import")}
                fontSize="18px"
                fontWeight="700"
                marginBottom="14px"
              />
              <BaseLabel
                children={t("auth.certificate.enterCode")}
                fontSize="14px"
                fontWeight="500"
                marginBottom="150px"
              />
            </DivLogo>
            <DivEmail>
              <Multiline
                label=""
                name=""
                onChange={(e) => setValue(e)}
                value={value}
                showLabelBase={false}
                marginBottom="30px"
                error={error}
                height="464px"
                rows={19}
              />
            </DivEmail>
            <Button id="sign-in_button" type="submit" marginBottom="16px">
              {t("common.continue")}
            </Button>
          </Grid>
        </Grid>
      </form>
      <LinkContainer type="submit" onClick={() => navigate("/")}>
        <TextLink>{t("auth.certificate.backToLogin")}</TextLink>
      </LinkContainer>
    </LeftFormContainer>
  );
};
